import type { ThemeSlots } from "../../types";

/**
 * ElevenLabs slot overrides. Empty — the theme ships only tokens.css and a
 * thin overrides.css (button radius, link colour). It reuses every default
 * component via `extends: "default"`.
 */
export const slots: ThemeSlots = {};
